// Mock database for users
export const mockUsers = [
  {
    id: 1,
    mobile: '9876543210',
    email: 'admin@example.com',
    username: 'admin',
    password: 'admin123',
    role: 'admin',
    name: 'Admin'
  },
  {
    id: 2,
    mobile: '9876543211',
    email: 'employee@example.com',
    username: 'employee',
    password: 'emp123',
    role: 'employee',
    name: 'John Employee'
  },
  {
    id: 3,
    mobile: '9876543212',
    email: 'accountant@example.com',
    username: 'accountant',
    password: 'acc123',
    role: 'accountant',
    name: 'Jane Accountant'
  },
  {
    id: 4,
    mobile: '9876543213',
    email: 'customer@example.com',
    username: 'customer',
    password: 'cust123',
    role: 'customer',
    name: 'Bob Customer'
  }
];

// Mock shipments data
export const mockShipments = [
  {
    id: 1,
    awbNumber: '05702758932',
    username: 'customer',
    customerName: 'Bob Customer',
    sbNumber: 'SB/2025/001',
    sbDate: '2025-12-18',
    cityCode: 'BOM',
    destCity: 'New York',
    destCountry: 'USA',
    flightNo: 'AI101',
    flightDate: '2025-12-20',
    totalPkt: '10',
    weight: '50 kg',
    chWeight: '55 kg',
    amount: '₹50,000',
    activity: 'Export',
    fob: '₹48,000',
    dbk: '₹1,000',
    rodtep: '₹500',
    rosctl: '₹300',
    igst: '₹5,000',
    awbCopy: 'mock-awb.pdf',
    leo: 'mock-leo.pdf',
    invPl: 'mock-inv.pdf',
    type: 'Air-Export',
    origin: 'Mumbai',
    destination: 'New York',
    shipmentDate: '2025-12-20',
    expectedDelivery: '2025-12-27',
    status: 'In Transit',
    customerId: 4,
    pdf1: null,
    pdf2: null,
    pdf3: null,
    pdf4: null,
    pdf5: null
  },
  {
    id: 2,
    awbNumber: '17685934201',
    username: 'customer',
    customerName: 'Bob Customer',
    sbNumber: 'SB/2025/002',
    sbDate: '2025-12-13',
    cityCode: 'MAA',
    destCity: 'Singapore',
    destCountry: 'Singapore',
    flightNo: 'N/A',
    flightDate: 'N/A',
    totalPkt: '50',
    weight: '500 kg',
    chWeight: '510 kg',
    amount: '₹2,50,000',
    activity: 'Export',
    fob: '₹2,40,000',
    dbk: '₹5,000',
    rodtep: '₹2,500',
    rosctl: '₹1,500',
    igst: '₹25,000',
    awbCopy: null,
    leo: 'mock-leo.pdf',
    invPl: 'mock-inv.pdf',
    type: 'Sea-Export',
    origin: 'Chennai',
    destination: 'Singapore',
    shipmentDate: '2025-12-15',
    expectedDelivery: '2026-01-05',
    status: 'Delivered',
    customerId: 4,
    pdf1: null,
    pdf2: null,
    pdf3: null,
    pdf4: null,
    pdf5: null
  },
  {
    id: 3,
    awbNumber: '23894567123',
    username: 'customer',
    customerName: 'Bob Customer',
    sbNumber: 'SB/2025/003',
    sbDate: '2025-12-20',
    cityCode: 'DEL',
    destCity: 'Delhi',
    destCountry: 'India',
    flightNo: 'EK502',
    flightDate: '2025-12-22',
    totalPkt: '5',
    weight: '30 kg',
    chWeight: '32 kg',
    amount: '₹30,000',
    activity: 'Import',
    fob: '₹28,000',
    dbk: '₹500',
    rodtep: '₹250',
    rosctl: '₹150',
    igst: '₹3,000',
    awbCopy: 'mock-awb.pdf',
    leo: null,
    invPl: 'mock-inv.pdf',
    type: 'Air-Import',
    origin: 'Dubai',
    destination: 'Delhi',
    shipmentDate: '2025-12-22',
    expectedDelivery: '2025-12-26',
    status: 'Customs Clearance',
    customerId: 4,
    pdf1: null,
    pdf2: null,
    pdf3: null,
    pdf4: null,
    pdf5: null
  },
  {
    id: 4,
    awbNumber: '39201845672',
    username: 'customer',
    customerName: 'Bob Customer',
    sbNumber: 'SB/2025/004',
    sbDate: '2025-11-28',
    cityCode: 'CCU',
    destCity: 'Kolkata',
    destCountry: 'India',
    flightNo: 'N/A',
    flightDate: 'N/A',
    totalPkt: '100',
    weight: '1000 kg',
    chWeight: '1020 kg',
    amount: '₹5,00,000',
    activity: 'Import',
    fob: '₹4,80,000',
    dbk: '₹10,000',
    rodtep: '₹5,000',
    rosctl: '₹3,000',
    igst: '₹50,000',
    awbCopy: null,
    leo: null,
    invPl: 'mock-inv.pdf',
    type: 'Sea-Import',
    origin: 'Shanghai',
    destination: 'Kolkata',
    shipmentDate: '2025-11-30',
    expectedDelivery: '2025-12-28',
    status: 'In Transit',
    customerId: 4,
    pdf1: null,
    pdf2: null,
    pdf3: null,
    pdf4: null,
    pdf5: null
  }
];

// Mock function to check if user exists
export const checkUserExists = (mobile) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const user = mockUsers.find(u => u.mobile === mobile);
      resolve(user ? true : false);
    }, 500);
  });
};

// Mock function to verify OTP
export const verifyOTP = (mobile, otp) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // Mock OTP is always '123456' for testing
      if (otp === '123456') {
        const user = mockUsers.find(u => u.mobile === mobile);
        resolve({ success: true, user });
      } else {
        resolve({ success: false, message: 'Invalid OTP' });
      }
    }, 500);
  });
};

// Mock function to login with email/username
export const loginWithCredentials = (identifier, password) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const user = mockUsers.find(
        u => (u.email === identifier || u.username === identifier) && u.password === password
      );
      if (user) {
        resolve({ success: true, user });
      } else {
        resolve({ success: false, message: 'Invalid credentials' });
      }
    }, 500);
  });
};
